import * as _ from 'underscore';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { AccountService } from '../../../app.retailer/modules/account/account.service';

interface ICategory<T> {
    Subcategories?: T[];
}

export abstract class CategoriesServiceBase<T extends ICategory<T>> {
    protected list: T[] = null;
    protected tree: {[key: number]: T[]} = {};

    public abstract categoryType: number;

    constructor(
        protected http: HttpService,
    ) { }

    protected abstract getApiUrl(): string;

    public async getTree(languageId: number) {
        if (!this.tree[languageId]) {
            this.tree[languageId] = await this.http.get<T[]>(this.getApiUrl());
        }
        return this.tree[languageId];
    }

    public async getList() {
        if (!this.list) {
            const tree = await this.getTree(1);
            this.list = this.flattenCategories(tree);
        }
        return this.list;
    }

    public flattenCategories(categories: T[]): T[] {
        let flatten = [];
        categories.forEach((category) => {
            flatten = flatten.concat(this.flattenCategory(category));
        });
        return flatten;
    }

    protected flattenCategory(category: T): T[] {
        let result = [category];

        if (category.Subcategories) {
            _.forEach(category.Subcategories, (subcategory) => {
                result = result.concat(this.flattenCategory(subcategory));
            });
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/categories/categories.service.ts